module.exports = __webpack_public_path__ + "static/img/logo.e8f8e7a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/logo.png
// module id = 4Wy2
// module chunks = 1